var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "chat-audit" },
    [
      _vm._m(0),
      _vm.error
        ? _c("el-alert", {
            staticClass: "audit-error",
            attrs: { title: _vm.error, type: "error", closable: false },
          })
        : _vm._e(),
      !_vm.authorized
        ? _c(
            "div",
            { staticClass: "audit-empty" },
            [
              _c("i", { staticClass: "el-icon-lock" }),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.checking
                      ? "正在核验权限…"
                      : "需要 OA聊天超级管理员 角色才能查看"
                  )
                ),
              ]),
              !_vm.checking
                ? _c("el-button", { on: { click: _vm.init } }, [
                    _vm._v("重新核验"),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _c("div", { staticClass: "audit-columns" }, [
            _c(
              "aside",
              { staticClass: "people-panel" },
              [
                _c("div", { staticClass: "panel-title" }, [
                  _vm._v("1 · 选择员工"),
                ]),
                _c("el-input", {
                  attrs: {
                    clearable: "",
                    placeholder: "搜索姓名、工号",
                    "prefix-icon": "el-icon-search",
                  },
                  on: { input: _vm.searchPeople },
                  model: {
                    value: _vm.peopleKeyword,
                    callback: function ($$v) {
                      _vm.peopleKeyword = $$v
                    },
                    expression: "peopleKeyword",
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "panel-scroll",
                    on: { scroll: _vm.scrollPeople },
                  },
                  [
                    _vm._l(_vm.people, function (p) {
                      return _c(
                        "button",
                        {
                          key: p.id,
                          staticClass: "person-row",
                          class: {
                            selected: _vm.employee && _vm.employee.id === p.id,
                          },
                          attrs: { "data-user-id": p.id },
                          on: {
                            click: function ($event) {
                              return _vm.selectEmployee(p)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "avatar" }, [
                            _vm._v(_vm._s(_vm.initial(p.name))),
                          ]),
                          _c("span", [
                            _c("strong", [
                              _vm._v(_vm._s(p.name || "已删除员工")),
                            ]),
                            _c("small", [
                              _vm._v(
                                _vm._s(p.serial || "无工号") +
                                  " · " +
                                  _vm._s(p.department || "未设置部门")
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    !_vm.people.length && !_vm.peopleLoading
                      ? _c("p", { staticClass: "empty-small" }, [
                          _vm._v("暂无符合条件的聊天人员"),
                        ])
                      : _vm._e(),
                    _vm.peopleMore
                      ? _c(
                          "el-button",
                          {
                            staticClass: "load-button",
                            attrs: { type: "text", loading: _vm.peopleLoading },
                            on: { click: _vm.loadPeople },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.peopleLoading ? "正在加载…" : "加载更多员工"
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "aside",
              { staticClass: "conversations-panel" },
              [
                _c("div", { staticClass: "panel-title" }, [
                  _vm._v(
                    "2 · " +
                      _vm._s(
                        _vm.employee
                          ? _vm.employee.name + " 的会话"
                          : "选择会话"
                      )
                  ),
                ]),
                _c("el-input", {
                  attrs: {
                    clearable: "",
                    disabled: !_vm.employee,
                    placeholder: "搜索同事或群名称",
                    "prefix-icon": "el-icon-search",
                  },
                  on: { input: _vm.searchConversations },
                  model: {
                    value: _vm.conversationKeyword,
                    callback: function ($$v) {
                      _vm.conversationKeyword = $$v
                    },
                    expression: "conversationKeyword",
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "panel-scroll",
                    on: { scroll: _vm.scrollConversations },
                  },
                  [
                    _vm._l(_vm.conversations, function (c) {
                      return _c(
                        "button",
                        {
                          key: c.id,
                          staticClass: "conversation-row",
                          class: {
                            selected:
                              _vm.conversation && _vm.conversation.id === c.id,
                          },
                          attrs: { "data-conversation-id": c.id },
                          on: {
                            click: function ($event) {
                              return _vm.selectConversation(c)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "avatar",
                              class: { group: c.conversationType === "GROUP" },
                            },
                            [
                              c.conversationType === "GROUP"
                                ? _c("i", { staticClass: "el-icon-s-custom" })
                                : [_vm._v(_vm._s(_vm.initial(c.peerName)))],
                            ],
                            2
                          ),
                          _c("span", { staticClass: "conversation-copy" }, [
                            _c("strong", [
                              _vm._v(_vm._s(c.peerName || "未命名会话") + " "),
                              c.conversationType === "GROUP"
                                ? _c("em", [_vm._v("群聊")])
                                : _vm._e(),
                            ]),
                            _c("small", [
                              _vm._v(_vm._s(_vm.preview(c.preview))),
                            ]),
                            _c("time", [_vm._v(_vm._s(_vm.date(c.updatedAt)))]),
                          ]),
                        ]
                      )
                    }),
                    !_vm.conversations.length && !_vm.conversationLoading
                      ? _c("p", { staticClass: "empty-small" }, [
                          _vm._v(
                            _vm._s(
                              _vm.employee
                                ? "暂无符合条件的会话"
                                : "请先选择左侧员工"
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm.conversationMore && _vm.employee
                      ? _c(
                          "el-button",
                          {
                            staticClass: "load-button",
                            attrs: {
                              type: "text",
                              loading: _vm.conversationLoading,
                            },
                            on: { click: _vm.loadConversations },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.conversationLoading
                                  ? "正在加载…"
                                  : "加载更多会话"
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "main",
              { staticClass: "messages-panel" },
              [
                _vm.conversation
                  ? [
                      _c(
                        "header",
                        { staticClass: "conversation-heading" },
                        [
                          _c("div", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.conversation.peerName)),
                            ]),
                            _c("small", [
                              _vm._v(
                                "以 " +
                                  _vm._s(_vm.employee.name) +
                                  " 的方向显示 · 查看不会改变已读状态"
                              ),
                            ]),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", icon: "el-icon-refresh" },
                              on: {
                                click: function ($event) {
                                  return _vm.selectConversation(
                                    _vm.conversation
                                  )
                                },
                              },
                            },
                            [_vm._v("回到最新")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          ref: "messages",
                          staticClass: "messages-scroll",
                          on: { scroll: _vm.scrollMessages },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "history-control" },
                            [
                              _vm.olderMore
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        loading: _vm.messageLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.loadMessages(true)
                                        },
                                      },
                                    },
                                    [_vm._v("加载更早消息")]
                                  )
                                : !_vm.messageLoading
                                ? _c("span", [_vm._v("已到最早的保留记录")])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.messageLoading && !_vm.messages.length
                            ? _c("p", { staticClass: "empty-small" }, [
                                _vm._v("正在读取消息…"),
                              ])
                            : _vm._e(),
                          !_vm.messageLoading && !_vm.messages.length
                            ? _c("p", { staticClass: "empty-small" }, [
                                _vm._v("此会话暂无消息"),
                              ])
                            : _vm._e(),
                          _vm._l(_vm.messages, function (m) {
                            return _c(
                              "article",
                              {
                                key: m.id,
                                staticClass: "message",
                                class: {
                                  mine:
                                    Number(m.senderId) ===
                                    Number(_vm.employee.id),
                                },
                                attrs: { "data-message-id": m.id },
                              },
                              [
                                _c("div", { staticClass: "message-meta" }, [
                                  _vm._v(
                                    _vm._s(m.senderName || "未知成员") +
                                      " · " +
                                      _vm._s(_vm.date(m.sentAt))
                                  ),
                                ]),
                                m.recalledAt
                                  ? _c("div", { staticClass: "recalled" }, [
                                      _vm._v("此消息已撤回"),
                                    ])
                                  : _c(
                                      "div",
                                      { staticClass: "bubble" },
                                      [
                                        m.type === "TEXT"
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "message-text" },
                                                _vm._l(
                                                  _vm.styledText(m),
                                                  function (part, i) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key: i,
                                                        style: part.style,
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(part.text)
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          : m.attachmentId
                                          ? [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "attachment",
                                                  attrs: {
                                                    disabled: !!m.fileDeleted,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openAttachment(
                                                        m
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "file-symbol",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.messageType(
                                                            m.type
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          m.fileName ||
                                                            _vm.messageType(
                                                              m.type
                                                            )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("small", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.size(m.fileSize)
                                                        ) +
                                                          _vm._s(
                                                            m.durationSeconds
                                                              ? " · " +
                                                                  m.durationSeconds +
                                                                  " 秒"
                                                              : ""
                                                          )
                                                      ),
                                                    ]),
                                                    _c("small", [
                                                      _vm._v(
                                                        _vm._s(
                                                          m.fileDeleted
                                                            ? "附件已删除或不可用"
                                                            : "点击预览 / 下载"
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-arrow-right",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : m.collaboration
                                          ? _c(
                                              "div",
                                              { staticClass: "collaboration" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.messageType(m.type)
                                                    )
                                                  ),
                                                ]),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      m.collaboration.title
                                                    )
                                                  ),
                                                ]),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      m.collaboration.content
                                                    )
                                                  ),
                                                ]),
                                                m.collaboration.startAt
                                                  ? _c("small", [
                                                      _vm._v(
                                                        "开始：" +
                                                          _vm._s(
                                                            _vm.date(
                                                              m.collaboration
                                                                .startAt
                                                            )
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                m.collaboration.endAt
                                                  ? _c("small", [
                                                      _vm._v(
                                                        "结束 / 截止：" +
                                                          _vm._s(
                                                            _vm.date(
                                                              m.collaboration
                                                                .endAt
                                                            )
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                m.collaboration.remindAt
                                                  ? _c("small", [
                                                      _vm._v(
                                                        "提醒：" +
                                                          _vm._s(
                                                            _vm.date(
                                                              m.collaboration
                                                                .remindAt
                                                            )
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "message-text" },
                                              [
                                                _vm._v(
                                                  "[" +
                                                    _vm._s(
                                                      _vm.messageType(m.type)
                                                    ) +
                                                    "] " +
                                                    _vm._s(
                                                      m.content ||
                                                        "该记录无可显示正文"
                                                    )
                                                ),
                                              ]
                                            ),
                                      ],
                                      2
                                    ),
                              ]
                            )
                          }),
                          _vm.windowTrimmed
                            ? _c("div", { staticClass: "window-tip" }, [
                                _vm._v(
                                  "为保持流畅，页面保留最近加载的 500 条。可继续向上查看更早记录，或点击“回到最新”。"
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  : _c("div", { staticClass: "audit-empty" }, [
                      _c("i", { staticClass: "el-icon-chat-dot-square" }),
                      _c("h3", [_vm._v("选择会话后查看聊天记录")]),
                      _c("p", [
                        _vm._v(
                          "文字、表情、图片、音视频、文件、日程、待办与钉一下"
                        ),
                      ]),
                    ]),
              ],
              2
            ),
          ]),
      _vm.attachment
        ? _c("audit-preview", {
            key: _vm.attachment.id,
            attrs: { file: _vm.attachment, prefix: _vm.attachmentPrefix },
            on: {
              close: function ($event) {
                _vm.attachment = null
              },
              denied: _vm.deny,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "audit-heading" }, [
      _c("div", [
        _c("h2", [_vm._v("查看所有聊天记录")]),
        _c("p", [_vm._v("选择员工，查看其关联会话及保留的历史消息")]),
      ]),
      _c("span", { staticClass: "read-only" }, [
        _c("i", { staticClass: "el-icon-view" }),
        _vm._v(" 管理员只读查看"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }